<template>
  <div class="iframe-container">
    <iframe :src="url" frameborder="0"></iframe>
  </div>
</template>
<script>
export default {
  data: () => ({
    url: 'https://test-examfront.xiaohoucode.com/#/login/test/10263?code=8jvcpk4f'
  }),
}
</script>
<style lang="less" scoped>
.iframe-container {
  width: 100%;
  height: 100%;
  iframe {
    width: 100%;
    height: 100%;
  }
}
</style>